<!-- @format -->

<template>
	<div class="pc-layout-page-common" :style="{ padding: getPx(params.margin) }">
		<pc-bread-crumb
			v-if="params.showBread"
			:crumb-list="crumbList"
			@click-crumb="(...args) => emits('click-crumb', ...args)"
		>
			<template #title>
				<slot name="title"></slot>
			</template>
			<template #extra>
				<slot name="extra"></slot>
			</template>
		</pc-bread-crumb>
		<div class="pc-layout-page-common-content" :style="{ padding: getPx(params.padding) }">
			<slot></slot>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { PcBreadCrumb } from '@/components/pc-bread-crumb/index';

	type CrumbList = { label: string; url: string }[];

	interface Props {
		noPadding?: boolean;
		noMargin?: boolean;
		pagePadding?: number;
		pageMargin?: number;
		showBread?: boolean;
		crumbList?: CrumbList | ((c: CrumbList) => CrumbList);
	}

	const props = withDefaults(defineProps<Props>(), {
		showBread: true,
	});

	const emits = defineEmits(['click-crumb']);

	const route = useRoute();

	/*
		   plpc ==== pc-layout-page-common
		   plpcp ==== pc-layout-page-common-padding
		   plpcm ==== pc-layout-page-common-margin
		   plpcb ==== pc-layout-page-common-bread
		 */
	const params = computed(() => ({
		padding: Object.hasOwnProperty.call(route.query, 'plpcp')
			? route.query.plpcp
			: props.noPadding
			? 0
			: props.pagePadding,
		margin: Object.hasOwnProperty.call(route.query, 'plpcm')
			? route.query.plpcm
			: props.noMargin
			? 0
			: props.pageMargin,
		showBread: Object.hasOwnProperty.call(route.query, 'plpcb') ? !(route.query.plpcb === '0') : props.showBread,
	}));

	const getPx = (num) => {
		if (typeof num === 'string') {
			const numb = num.split(',').reduce((str, px) => (str ? `${str} ${px}px` : `${px}px`), '');
			return numb;
		}
		return `${num}px`;
	};
</script>

<style scoped lang="scss">
	.pc-layout-page-common {
		width: 100%;
		height: 100%;
		background-color: var(--theme-bg-color);
		padding: var(--theme-pc-layout-page-common-margin);
		display: flex;
		flex-direction: column;
		gap: 12px;

		.pc-layout-page-common-content {
			flex: 1;
			width: 100%;
			padding: var(--theme-pc-layout-page-common-padding);
			background-color: var(--theme-fill-color-blank);
			overflow: auto;
		}
	}
</style>
